/*
 * Puuki — Mobiilifilteröinnin parannukset
 * - Näyttää FAB-painikkeen kun käyttäjä scrollaa alas mobiilissa
 * - Päivittää sticky CTA:n tuoteluvun kun filtteri muuttuu (Dawnin AJAX-kutsun jälkeen)
 * - Päivittää aktiivisten filterien badgea ("Suodata (3)")
 */

(function () {
  'use strict';

  const FAB_SHOW_THRESHOLD = 400; // pikseliä alaspäin scrollatessa FAB ilmestyy
  const MOBILE_BREAKPOINT = 989;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  /* ----------------------------------------------------------
     1. FAB scroll-näkyvyys
  ---------------------------------------------------------- */
  function setupFAB() {
    const fab = document.querySelector('[data-puuki-fab]');
    if (!fab) return;

    let ticking = false;

    function updateFAB() {
      const scrolled = window.scrollY > FAB_SHOW_THRESHOLD;
      if (scrolled && isMobile()) {
        fab.classList.add('is-visible');
      } else {
        fab.classList.remove('is-visible');
      }
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateFAB);
          ticking = true;
        }
      },
      { passive: true }
    );

    // FAB-klikkaus avaa drawerin
    fab.addEventListener('click', () => {
      const summary = document.querySelector('.mobile-facets__wrapper summary');
      if (summary) summary.click();
    });

    // Initial state
    updateFAB();
  }

  /* ----------------------------------------------------------
     2. Live-count päivitys: kuuntele Dawnin facet-AJAX-kutsuja
     Dawn lähettää custom-eventin "facets:updated" tai päivittää
     mobile-facets__count -elementtiä. Synkronisoidaan oma sticky CTA.
  ---------------------------------------------------------- */
  function setupLiveCount() {
    // Päivittää sticky CTA:n laskurit tuotteiden kokonaismäärästä
    function syncCount() {
      const sourceEl = document.querySelector('.mobile-facets__count');
      if (!sourceEl) return;

      const targets = document.querySelectorAll('[data-puuki-product-count]');
      // Ota ensimmäinen numero lähdetekstistä (esim. "12 of 82" tai "82 tuotetta")
      const text = sourceEl.textContent.trim();
      const match = text.match(/\d+/);
      if (!match) return;
      const count = match[0];
      targets.forEach((t) => (t.textContent = count));
    }

    // MutationObserver kuuntelee mobile-facets__count -elementin muutoksia
    const countEl = document.querySelector('.mobile-facets__count');
    if (countEl) {
      const observer = new MutationObserver(syncCount);
      observer.observe(countEl, { childList: true, characterData: true, subtree: true });
    }

    // Aktiivisten badgen päivitys: laske checkboxit jotka on valittu mobile-formissa
    function syncActiveBadge() {
      const form = document.querySelector('#FacetFiltersFormMobile');
      if (!form) return;

      const checked = form.querySelectorAll(
        'input[type="checkbox"]:checked, input[type="radio"]:checked'
      ).length;

      // Lasketaan myös hinta-rangejen valinnat
      const priceInputs = form.querySelectorAll(
        'input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]'
      );
      let priceActive = 0;
      priceInputs.forEach((i) => {
        if (i.value && i.value !== '') priceActive = 1;
      });

      const total = checked + priceActive;
      const badges = document.querySelectorAll('[data-puuki-active-count]');

      badges.forEach((b) => {
        if (total > 0) {
          b.textContent = total;
          b.style.display = '';
        } else {
          b.style.display = 'none';
        }
      });
    }

    // Kuuntele formin muutoksia
    document.addEventListener('change', (e) => {
      if (e.target.closest('#FacetFiltersFormMobile, #FacetFiltersForm')) {
        // Pieni viive jotta Dawnin oma logiikka ehtii ajaa ensin
        setTimeout(syncActiveBadge, 50);
      }
    });

    // Run once on load
    syncActiveBadge();
    syncCount();
  }

  /* ----------------------------------------------------------
     Initialize
  ---------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupFAB();
      setupLiveCount();
    });
  } else {
    setupFAB();
    setupLiveCount();
  }

  // Re-init kun Dawn re-renderöi facetit (section-render API)
  document.addEventListener('shopify:section:load', () => {
    setupFAB();
    setupLiveCount();
  });
})();
